<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create Site'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="domain"
            label="* Name"
            v-model="form.domain"
            :error="errors.domain ? errors.domain[0] : null"
        />
        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700 dark:text-gray-200" for="cluster_id">Cluster</label>
            <select2
                :options="clusters"
                key="clusters"
                :multiple="false"
                id="clusters"
                select-label="name"
                track-by-option="id"
                name="cluster"
                ref="cluster"
                @sync="clusterChanged"
                class="mt-1"
            />
            <div v-if="errors.cluster_id" class="invalid-feedback">
                {{ errors.cluster_id.join("\r\n") }}
            </div>
        </div>
        <div class="mt-6 max-w-4xl">
            <label class="block text-gray-700 dark:text-gray-200" for="cluster_id"
                >Language</label
            >
            <select2
                :options="languages"
                key="languages"
                :multiple="false"
                id="site_language_id"
                select-label="name"
                track-by-option="id"
                name="site_language"
                ref="site_language"
                class="mt-1"
                @sync="languageChanged"
            />
            <div v-if="errors.site_language_id" class="invalid-feedback">
                {{ errors.site_language_id.join("\r\n") }}
            </div>
        </div>

        <Select
            label="Is Active (and should be used for automatic Hreflangs)?"
            name="active"
            v-model="form.active"
            class="mt-2"
            :options="[
                {value: 0, name: 'No', default: true},
                {value: 1, name: 'Yes'},
            ]"
            :error="errors.active ? errors.active[0] : null"
        />

        <Select
            label="Is Active on Cluster?"
            name="active_on_cluster"
            v-model="form.active_on_cluster"
            class="mt-2"
            :options="[
                {value: 0, name: 'No'},
                {value: 1, name: 'Yes'},
            ]"
            :error="errors.active_on_cluster ? errors.active_on_cluster[0] : null"
        />

        <input-text
            name="astro_site"
            label="Astro Site"
            v-model="form.astro_site"
            :error="errors.astro_site ? errors.astro_site[0] : null"
            class="mt-6"
        />

        <input-text
            name="digitalocean_space_name"
            label="Digital Ocean Space Name"
            v-model="form.digitalocean_space_name"
            :error="errors.digitalocean_space_name ? errors.digitalocean_space_name[0] : null"
            class="mt-6"
        />

        <input-text
            type="number"
            name="order"
            label="Order"
            v-model="form.order"
            :error="errors.order ? errors.order[0] : null"
            class="mt-6"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
import InputText from "./form/InputText.vue";
export default {
    name: "SiteForm",
    components: {InputText},
    mixins: [crudForm],
    props: ["clusters", "languages"],
    data() {
        return {
            form: {
                domain: this.getFormData("domain"),
                astro_site: this.getFormData("astro_site"),
                cluster: this.getFormData("cluster"),
                cluster_id: this.getFormData("cluster_id"),
                site_language: this.getFormData("language"),
                site_language_id: this.getFormData("site_language_id"),
                digitalocean_space_name: this.getFormData("digitalocean_space_name"),
                active: this.getFormData("active",0),
                active_on_cluster: this.getFormData("active_on_cluster",0),
                order: this.getFormData("order"),
            },
        };
    },
    mounted() {
       this.$refs.cluster.selected = this.form.cluster;
       this.$refs.site_language.selected = this.form.site_language;
    },
    watch: {
        "form.cluster": function (newValue) {
            this.form.cluster_id = newValue ? newValue.id : null;
        },
        "form.site_language": function (newValue) {
            this.form.site_language_id = newValue ? newValue.id : null;
        }
    },
    methods: {
        clusterChanged(value) {
            if (value) {
                this.form.cluster_id = value;
            }
        },
        languageChanged(value) {
            if (value) {
                this.form.site_language_id = value;
            }
        },
    },
};
</script>
